export interface WrapPanelWidth {
  md: string;
  lg?: string;
  sm?: string;
  xs?: string;
}
